/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Icon } from '../../ui/Icon';
import * as Styles from './index.styles';

import ProgressIcon from './progressIcon.svg';

export const FormStateArr = {
  DEFAULT: 'DEFAULT',
  FILLING: 'FILLING',
  PROGRESS: 'PROGRESS',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

class AnimFormButton extends SafePureComponent {
  getButtonLabel = () => {
    const { label, formState } = this.props;

    if (formState === FormStateArr.DEFAULT) {
      return label;
    }
    if (formState === FormStateArr.ERROR) {
      return (
        <span>
          {/* <img src={ErrorIcon} alt="error-icon" /> */}
          <Icon name="error" />
        </span>
      );
    }
    if (formState === FormStateArr.PROGRESS) {
      return (
        <span>
          <img src={ProgressIcon} alt="progress-icon" />
        </span>
      );
    }
    if (formState === FormStateArr.SUCCESS) {
      return (
        <span>
          <Icon name="check" />
        </span>
      );
    }
  };

  safeRender() {
    const { buttonProps, formState } = this.props;
    const { css, ...restButtonProps } = buttonProps;

    return (
      <button
        {...restButtonProps}
        css={[Styles.common, Styles.formStateStyle[formState], ...css]}
      >
        {this.getButtonLabel()}
      </button>
    );
  }
}

AnimFormButton.displayName = 'AnimFormButton';

export default AnimFormButton;
